export const getCustomPaymentTypes = (state) =>
  Object.values(state.customPaymentTypes.byId)

export const getCustomPaymentType = (state, uuid) =>
  state?.customPaymentTypes?.byId[uuid] ?? {}

export const getIsCustomPaymentTypesLoading = (state) =>
  state?.customPaymentTypes?.isLoading ?? false

export const getCustomPaymentTypesValue = (state) =>
  state?.customPaymentTypes?.filters?.searchCustomPaymentTypesValue ??
  ''
